import React from "react";
import * as styles from "./styles.module.scss";
import socialInstagramIcon from "./social-instagram.svg";
import socialFacebookIcon from "./social-facebook.svg";
import socialTwitterIcon from "./social-twitter.svg";
import socialYouTubeIcon from "./social-youtube.svg";
import socialLinkedinIcon from "./social-linkedin.svg";
import cx from "classname";

const imageMap = {
  instagram: socialInstagramIcon,
  facebook: socialFacebookIcon,
  twitter: socialTwitterIcon,
  youtube: socialYouTubeIcon,
  linkedin: socialLinkedinIcon
};

function SocialMediaList({ className, size, allowList, links }) {
  return (
    <div className={className}>
      <ul className={cx(styles.container, styles[size])}>
        {Object.values(links).map((entry) => {
          if (!allowList || allowList.indexOf(entry.key) > -1) {
            return (
              <li key={entry.key}>
                <a href={entry.url} target="_blank" rel="noreferrer">
                  <img
                    src={imageMap[entry.key]}
                    alt={entry.label}
                    width={40}
                    height={40}
                    loading="lazy"
                  />
                </a>
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );
}

SocialMediaList.defaultProps = {
  size: "large",
  allowList: null
};
export default SocialMediaList;
